import { Entities } from "../../entityDalFactory"

export const CommonConstants = (entity: Entities) => ({
  SendRequest: `${entity}_SendRequest`,
  RequestOk: `${entity}_RequestOk`,
  RequestKO: `${entity}_RequestKO`
})
